import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/manhwa';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = heroSlides.length;

  const goToSlide = useCallback((index: number) => {
    setCurrentSlide(index);
  }, []);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  }, [totalSlides]);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="relative w-full h-[480px] md:h-[620px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
            index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
        </div>
      ))}

      <div className="relative z-20 w-full h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
          <div className="max-w-2xl">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-4">
              {heroSlides[currentSlide].subtitle}
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
              {heroSlides[currentSlide].title}
            </h2>
            <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6 max-w-lg">
              {heroSlides[currentSlide].description}
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <Link
                to={`/article/${heroSlides[currentSlide].slug}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </div>
                立即阅读
              </Link>
              <div className="flex items-center gap-3">
                <span className="flex items-center gap-1 text-white/80 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                  </div>
                  {heroSlides[currentSlide].rating}
                </span>
                <span className="text-white/50">|</span>
                <span className="text-white/80 text-sm">
                  共 {heroSlides[currentSlide].chapters} 话
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((slide, index) => (
          <button
            key={slide.id}
            onClick={() => goToSlide(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-white w-8'
                : 'bg-white/40 hover:bg-white/70'
            }`}
          />
        ))}
      </div>
    </section>
  );
}